<main>
  <section class="d-flex align-items-center justify-content-between">
    <h3 class="m-0">{{ 'header.contribute.manage.recurring.contribution' | translateLang }}</h3>
    <button class="lg-button m-0" (click)="goTo(urls.DONATE, { isRecurring: true })">
      {{ 'donate.manage.recurring.contribution.buttons.create' | translateLang }}
    </button>
  </section>

  <!-- TODO: Implement portal loading spinner -->
  <!-- <app-loading-spinner *ngIf="tableLoading$ | async; else tableLoaded"></app-loading-spinner> -->

  <ng-template #tableLoaded>
    <ng-container *ngIf="tableData$ | async as tableData">
      <section *ngIf="tableData?.length; else noData">
        <h4 class="mb-3">{{ 'donate.manage.recurring.contribution.list.header' | translateLang }}</h4>

        <span class="text-secondary">
          {{
            ((lastIndex$ | async) > (firstIndex$ | async)
              ? 'donate.manage.recurring.contribution.buttons.page.info.plural'
              : 'donate.manage.recurring.contribution.buttons.page.info.single'
            )
              | translateLang
                : {
                    firstIndex: (firstIndex$ | async),
                    lastIndex: (lastIndex$ | async),
                    totalItems: (totalItems$ | async)
                  }
          }}
        </span>

        <!-- TODO: Implement portal loading spinner -->
        <!-- <app-loading-spinner *ngIf="(pageLoading$ | async) && dateFormat; else pageLoaded"></app-loading-spinner> -->

        <ng-template #pageLoaded>
          <div class="overflow-x">
            <table class="table">
              <thead>
                <th class="text-center" *ngFor="let header of headers">{{ header | translateLang }}</th>
              </thead>
              <tbody>
                <tr *ngFor="let row of tableData">
                  <td class="text-center">{{ row.subscriptionId }}</td>
                  <td class="text-center">{{ row.entityName }}</td>
                  <td class="text-center">{{ row.contributionType }}</td>
                  <td class="text-center">{{ row.amount | number : '1.2-2' | numberFormat }} {{ row.currency }}</td>
                  <td class="text-center">
                    {{ 'donate.recurring.contribution.labels.pattern.' + (row.recurrencePattern | lowercase) | translateLang }}
                  </td>
                  <td class="text-center">{{ row.startDate | date : dateFormat }}</td>
                  <td class="text-center">{{ row.endDate | date : dateFormat }}</td>
                  <td class="text-center">{{ row.createdDate | date : dateFormat }}</td>
                  <td class="text-center">{{ row.status | titlecase }}</td>
                  <td class="text-center">
                    <a
                      class="table-link"
                      (click)="cancelSubscription(row.subscriptionId)"
                      [hidden]="row.status !== (paymentStatus.ACTIVE | titlecase)"
                    >
                      {{ 'general.cancel' | translateLang }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>

        <div class="d-flex justify-content-center">
          <pagination
            [boundaryLinks]="true"
            [totalItems]="totalItems$ | async"
            [disabled]="pageLoading$ | async"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
            firstText="&laquo;"
            lastText="&raquo;"
            (pageChanged)="onPageChanged($event)"
          ></pagination>
        </div>
      </section>

      <ng-template #noData>
        <div class="d-flex justify-content-center">
          <span>{{ 'donate.manage.recurring.contribution.no.data' | translateLang }}</span>
        </div>
      </ng-template>
    </ng-container>
  </ng-template>
</main>
